import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=5c5a793c&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=5c5a793c&prod&lang=scss&scoped=true"
import style1 from "./AppHeader.vue?vue&type=style&index=1&id=5c5a793c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a793c",
  null
  
)

export default component.exports